<script setup lang="ts">
    import type { HTMLAttributes } from 'vue';
    import { reactiveOmit } from '@vueuse/core';
    import { Check } from 'lucide-vue-next';
    import {
        SelectItem,
        SelectItemIndicator,
        type SelectItemProps,
        SelectItemText,
        useForwardProps,
    } from 'reka-ui';
    import { cn } from '@/lib/utils';

    const props = defineProps<SelectItemProps & { class?: HTMLAttributes['class'] }>();

    const delegatedProps = reactiveOmit(props, 'class');

    const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
    <SelectItem
        data-slot="select-item"
        v-bind="forwardedProps"
        :class="
            cn(
                `data-[state=checked]:text-primary focus:bg-primary/10 [&_svg:not([class*='text-'])]:text-muted-foreground relative flex w-full cursor-pointer items-center gap-2 rounded-sm py-1.5 pr-8 pl-2 text-xs outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 *:[span]:last:flex *:[span]:last:items-center *:[span]:last:gap-2`,
                // 'data-[state=checked]:text-primary',
                props.class,
            )
        "
    >
        <SelectItemText>
            <slot />
        </SelectItemText>

        <span class="absolute right-2 flex size-3.5 items-center justify-center">
            <SelectItemIndicator>
                <Check class="text-primary size-3" />
            </SelectItemIndicator>
        </span>
    </SelectItem>
</template>
